import { designTokens, detailPageStyles } from "utils/designSystem";

const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: designTokens.spacing.md,
  flexWrap: "wrap",
  padding: "16px 24px",
  borderBottom: `1px solid ${designTokens.colors.borderLight}`,
  backgroundColor: "#f8fafc",
};

const DetailSection = ({ title, actions, children }) => (
  <section aria-label={title} style={detailPageStyles.section}>
    <div style={headerStyle}>
      <h2 style={detailPageStyles.sectionTitle}>{title}</h2>
      {actions}
    </div>
    <div style={detailPageStyles.sectionContent}>{children}</div>
  </section>
);

export default DetailSection;
